module.exports = __webpack_public_path__ + "static/media/multihand_blackjack.pragmaticplay.7ee90ede.jpeg";